module.exports = __webpack_public_path__ + "img/angle-down.181f6bf2.svg";